export default "__VITE_ASSET__C7AqiNlb__"